import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'date-inativacao',
  templateUrl: './date-inativacao.component.html',
  styleUrls: ['./date-inativacao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DateInativacaoComponent implements OnInit {

  formGroup: FormGroup;
  now: string = new Date().toISOString().split('T')[0];

  constructor(
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() { }

  async ngAfterViewInit(){
    this.formGroup = this._controlContainer.control as FormGroup;
  }
}
